/** Workspace chrome only: never moves an iframe or recreates the editor. */
export function workspaceControls(shell: HTMLElement, workspace: HTMLElement, notify: (message: string) => void) {
  const divider = document.createElement('div');
  divider.className = 'hdp-divider'; divider.tabIndex = 0;
  divider.setAttribute('role', 'separator');
  divider.setAttribute('aria-label', 'Editor width');
  divider.setAttribute('aria-orientation', 'vertical');
  divider.setAttribute('aria-valuemin', '25'); divider.setAttribute('aria-valuemax', '65');
  shell.insertBefore(divider, workspace);
  let width = 30;
  const resize = (value: number) => {
    width = Math.min(65, Math.max(25, value));
    shell.style.setProperty('--hdp-editor-width', `${width}%`);
    divider.setAttribute('aria-valuenow', String(Math.round(width)));
  };
  resize(width);
  divider.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    resize(event.key === 'Home' ? 25 : event.key === 'End' ? 65 : width + (event.key === 'ArrowRight' ? 2 : -2));
  });
  divider.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    divider.setPointerCapture(event.pointerId);
    shell.classList.add('is-resizing');
  });
  divider.addEventListener('pointermove', event => {
    if (!divider.hasPointerCapture(event.pointerId)) return;
    const rect = shell.getBoundingClientRect();
    resize((event.clientX - rect.left) / rect.width * 100);
  });
  divider.addEventListener('pointerup', event => {
    if (divider.hasPointerCapture(event.pointerId)) divider.releasePointerCapture(event.pointerId);
  });
  divider.addEventListener('lostpointercapture', () => shell.classList.remove('is-resizing'));
  const fullscreenButton = workspace.querySelector<HTMLButtonElement>('[data-fullscreen]')!;
  const updateFullscreen = () => {
    const active = workspace.matches(':fullscreen');
    fullscreenButton.textContent = active ? 'Exit fullscreen' : 'Fullscreen';
    fullscreenButton.setAttribute('aria-pressed', String(active));
  };
  fullscreenButton.addEventListener('click', async () => {
    try {
      if (workspace.matches(':fullscreen')) await document.exitFullscreen();
      else await workspace.requestFullscreen();
    } catch { notify('Fullscreen is unavailable here. Allow fullscreen on the embedding iframe.'); }
  });
  document.addEventListener('fullscreenchange', updateFullscreen);
  return {
    setEditorVisible(visible: boolean) { divider.hidden = !visible; shell.classList.toggle('hdp-shell--preview', !visible); },
    destroy() {
      document.removeEventListener('fullscreenchange', updateFullscreen);
      if (workspace.matches(':fullscreen')) void document.exitFullscreen().catch(() => {});
    },
  };
}
